@if (loaded) {
  <form [formGroup]="form">
    @if (!cameFromOnboarding) {
      <tidy-row [align]="'center'">
        <tidy-text
          [title]="!address?.address_name ? (address?.address1 + (address?.address2 == null ? '' : address?.address2)) : address?.address_name"
          [translate]="false" />
      </tidy-row>
    }
    @if (cameFromAddIntegration) {
      <tidy-row [align]="'center'">
        <tidy-text
          [body]="integrationMessage" />
      </tidy-row>
    }
    <tidy-card>
      <tidy-row class="card-header">
        <tidy-image
          [src]="automaticBooking ? 'assets/img/automatic-booking.svg' : 'assets/img/automatic-booking-off.svg'"
          class="header-size" />
        <tidy-text
          [header]="'Auto-Schedule'" />
        <tidy-toggle
          [toggled]="automaticBooking"
          (toggleChanged)="automaticBooking = !automaticBooking" />
      </tidy-row>
      <tidy-row>
        <tidy-text
          [body]="'When a reservation is synced, automatically add a cleaning for your pros. Cancel anytime. '" />
        <tidy-text
          [actionBody]="'Learn More'"
          (action)="learnMoreAutomaticBooking()"
          class="link" />
      </tidy-row>
    </tidy-card>
    @if (automaticBooking) {
      <tidy-row [align]="'center'" class="extra-bottom-padding">
        <tidy-text
          [body]="'Set up Auto-Schedule:'" />
      </tidy-row>
      <form [formGroup]="form">
        @if (!cameFromOnboarding) {
          <tidy-card>
            <tidy-card-button (action)="goToIntegrations()" style="border-bottom:0px" class="card-header-arrow-to-top">
              <tidy-row [alignLastItemRight]="true" class="card-header card-header-with-card-button vertical-align-center">
                <tidy-image
                  [src]="'assets/img/integration.svg'"
                  class="header-size" />
                <tidy-text
                  [header]="'Integration(s)'" />
                <div style="margin-right:25px">
                  <tidy-text
                    [body]="integrations.length.toString()" /><span>&nbsp;</span>
                  <tidy-text
                    [body]="'Added'" />
                </div>
              </tidy-row>
              <tidy-row>
                @if (integrations.length > 0) {
                  <tidy-text
                    [body]="integrations.length.toString()" /><span>&nbsp;</span>
                  <tidy-text
                    [body]="integrations.length === 1 ? 'integration added' : 'integrations added'" />
                } @else {
                  <tidy-text
                    [body]="'Add at least 1 integration for this property.'" />
                }
              </tidy-row>
            </tidy-card-button>
          </tidy-card>
        }
        <tidy-card>
          <tidy-row class="card-header vertical-align-center">
            <tidy-image
              [src]="'assets/img/suitcase.svg'"
              class="header-size" />
            <tidy-text
              [header]="'Job(s) to Book'" />
          </tidy-row>
          @for (controlName of jobControls; track controlName; let i = $index) {
            <tidy-row [align]="'center'" [ngClass]="{'field-top-padding': true, 'extra-bottom-padding': i === jobControls.length - 1 && jobControls.length > 1}">
              <tidy-select
                [icon]="'assets/svg/information-circle.svg'"
                [label]="windowService.isDesktopRes ? 'Default job name*' : 'Default job name'"
                [formControlName]="controlName"
                [items]="jobItems"
                [form]="form.controls[controlName]" />
              @if (i > 0) {
                <tidy-text
                  [actionBody]="'Remove Job'"
                  (action)="removeJob(controlName)"
                  class="red link" />
              }
            </tidy-row>
          }
          <tidy-row [align]="'center'">
            <tidy-text
              [actionBody]="'Add Another Job'"
              (action)="addAnotherJob()"
              class="link" />
          </tidy-row>
          @if (windowService.isDesktopRes && !cameFromOnboarding) {
            <tidy-row class="extra-top-padding">
              <tidy-text
                [body]="'*You can customize the job name per pro/property '" />
              <tidy-text
                [actionBody]="'here'"
                class="link"
                (action)="goToMyProSettings()" />
            </tidy-row>
          }
        </tidy-card>
        <tidy-card>
          <tidy-row class="card-header vertical-align-center">
            <tidy-image
              [src]="'assets/img/clock-black.svg'"
              class="header-size" />
            <tidy-text
              [header]="'Job(s) Time Range'" />
          </tidy-row>
          <tidy-row class="field-bottom-padding">
            <tidy-select
              [icon]="'assets/svg/time.svg'"
              [label]="'Earliest start time (typically the check out time)'"
              [form]="form.controls.startTime"
              formControlName="startTime"
              (optionChange)="updateTimeOptions()"
              [items]="times.start" />
          </tidy-row>
          <tidy-row>
            <tidy-select
              [icon]="'assets/svg/time.svg'"
              [label]="'Latest finish time (typically the check in time)'"
              [form]="form.controls.endTime"
              formControlName="endTime"
              (optionChange)="updateTimeOptions()"
              [items]="times.end" />
          </tidy-row>
          @if (timeRangeErrorMessage) {
            <tidy-row class="extra-bottom-padding">
              <tidy-error-message
                [text]="timeRangeErrorMessage" />
            </tidy-row>
          }
          <tidy-row>
            <tidy-text
              [body]="'<b>Example:</b>'" />
          </tidy-row>
          <tidy-row [alignLastItemRight]="true">
            <tidy-text
              [body]="'Next synced reservation:'" />
            <tidy-text
              [body]="'Mar 1 - Mar 3'" />
          </tidy-row>
          <tidy-row [alignLastItemRight]="true">
            <tidy-text
              [body]="'Reservation after that:'" />
            <tidy-text
              [body]="'Mar 8 - Mar 10'" />
          </tidy-row>
          <tidy-row class="extra-top-padding">
            <tidy-text
              [body]="'These settings would add a'" /><span><span>&nbsp;</span></span>
              <tidy-text
                [body]="jobsList" /><span><span>&nbsp;</span></span>
                <tidy-text
                  [body]="'to start no earlier than March 3,'" /><span><span>&nbsp;</span></span>
                  <tidy-text
                    [body]="guestReservations.displayDate(form?.value?.startTime)" /><span><span>&nbsp;</span></span>
                    <tidy-text
                      [body]="'& be completed before March 8,'" /><span><span>&nbsp;</span></span>
                      <tidy-text
                        [body]="guestReservations.displayDate(form?.value?.endTime)" />
                    </tidy-row>
                  </tidy-card>
                  <tidy-card>
                    <tidy-row class="card-header vertical-align-center">
                      <tidy-image
                        [src]="'assets/img/search-calendar-enabled.svg'"
                        class="header-size" />
                      <tidy-text
                        [header]="'Job(s) Date Settings'" />
                    </tidy-row>
                    <tidy-row>
                      <tidy-select
                        [icon]="'assets/svg/information-circle.svg'"
                        [label]="'Create job requests no earlier than'"
                        [form]="form.controls.numberDaysPriorToCheckIn"
                        formControlName="numberDaysPriorToCheckIn"
                        [items]="numberDaysPriorToCheckInItems" />
                    </tidy-row>
                    <tidy-row>
                      <tidy-select
                        [icon]="'assets/svg/information-circle.svg'"
                        [label]="'Schedule jobs no later than'"
                        [form]="form.controls.maxDays"
                        formControlName="maxDays"
                        [items]="maxDaysItems" />
                    </tidy-row>
                    @if (form?.value?.maxDays == 0) {
                      <tidy-row class="extra-bottom-padding">
                        <tidy-text
                          [body]="'<b>Warning:</b> This setting makes it more difficult to fill jobs.'" />
                      </tidy-row>
                      <tidy-row>
                        <tidy-text
                          [body]="'This means pros are only allowed to accept a job same day as checkout. If they can\'t do it then, your job request will go to other pros following your priorities. This is recommended only if you commonly get last minute bookings within 1 day of a prior booking, and are ok with not getting the pro you prefer. '" />
                        <tidy-text
                          (action)="goToLearnMoreMaxDays()"
                          class="link"
                          [actionBody]="'Learn More'" />
                      </tidy-row>
                    }
                    @if (form?.value?.maxDays == 1 || form?.value?.maxDays == 2 || form?.value?.maxDays == 3) {
                      <tidy-row>
                        <tidy-text
                          [body]="'Pros are notified that a job same day as checkout is preferred, but are allowed to accept jobs up to'" /><span>&nbsp;</span>
                          <tidy-text
                            [body]="form?.value?.maxDays" /><span>&nbsp;</span>
                            <tidy-text
                              [body]="'days later or before check in, whatever is first. For most people, we recommend allowing up to 3 days before checkout, as it helps you get your favorite pros while still getting jobs done before check in.'" /><span>&nbsp;</span>
                              <tidy-text
                                (action)="goToLearnMoreMaxDays()"
                                class="link"
                                [actionBody]="'Learn More'" />
                            </tidy-row>
                          }
                        </tidy-card>
                        @if (!cameFromOnboarding) {
                          <tidy-card>
                            <tidy-card-button (action)="goToMyPros()" style="border-bottom:0px" class="card-header-arrow-to-top">
                              <tidy-row [alignLastItemRight]="true" class="card-header card-header-with-card-button vertical-align-center">
                                <tidy-image
                                  [src]="'assets/img/pros.svg'"
                                  class="header-size" />
                                <tidy-text
                                  [header]="'Your Pros'" />
                                <div style="margin-right:25px">
                                  <tidy-text
                                    [body]="proCount" /><span>&nbsp;</span>
                                    <tidy-text
                                      [body]="'Approved'" />
                                  </div>
                                </tidy-row>
                                <tidy-row class="extra-bottom-padding">
                                  <tidy-text
                                    [body]="'Job requests will be sent to pros in the order listed in the My Pros section.'" />
                                </tidy-row>
                                <tidy-row>
                                  <tidy-text
                                    [body]="'Pros you add will invoice you after each job at your agreed rates (no additional cost). You can opt to autopay each pro or not.'" />
                                </tidy-row>
                              </tidy-card-button>
                            </tidy-card>
                          }
                          <!--<tidy-card>
                          <tidy-row [alignLastItemRight]="true">
                            <tidy-row [alignLastItemRight]="true" class="full-width">
                              <tidy-image
                                [src]="'assets/img/search.svg'"
                                class="title-size">
                              </tidy-image>
                              <tidy-text
                                [header]="'Find New Pros'">
                              </tidy-text>
                              <div></div>
                            </tidy-row>
                            <tidy-toggle
                              [toggled]="findNewPro"
                              (toggleChanged)="updateFindNewPro()">
                            </tidy-toggle>
                          </tidy-row>
                          <tidy-row [ngClass]="findNewPro ? 'extra-bottom-padding' : ''">
                            <tidy-text
                              [body]="('New pros cost $' | translate) + serviceCost + (' for a ' | translate) + cleaningViewValue + '.'">
                            </tidy-text>
                          </tidy-row>
                          <tidy-row *ngIf="findNewPro">
                            <tidy-radio-button
                              [label]="'How do you want to pay new pros?'"
                              formControlName="payNewPros"
                              [form]="form.controls.payNewPros"
                              [items]="payNewProsOptions"
                              class="no-margin-first">
                            </tidy-radio-button>
                          </tidy-row>
                        </tidy-card>-->
                      </form>
                    }
                    @if (errorMessage) {
                      <tidy-error-message
                        [text]="errorMessage" />
                    }
                    <tidy-row>
                      <tidy-button
                        [text]="'Save Settings'"
                        [action]="boundSave"
                        class="primary" />
                    </tidy-row>
                    <tidy-row [align]="'center'">
                      <tidy-text
                        [body]="'Note: You can disable auto-schedule for individual reservations & cancel jobs anytime.'" />
                    </tidy-row>
                  </form>
                }
